import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import { withStyles, createStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import RootRef from '@material-ui/core/RootRef';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { Rnd } from 'react-rnd';
import { HotKeys } from 'react-hotkeys';
import FormError from '../../form/Error';
import Icon from '../../core/Icon';
import Button from '../../core/Button';
import omit from '../../utils/omit';
import Modal from '@material-ui/core/Modal';
import cx from 'classnames';
var ELEVATION_OFFSET_DEFAULT_TOP_PX = 8 * 4;
var ELEVATION_OFFSET_PX = 8 * 2;
var DEFAULT_ELEVATION = 4;
var BOTTOM_SPACE_PX = 8 * 4;
var HEADER_PX = 64;
var FOOTER_PX = 64;
/**
 * @typedef {object} ModalPosition
 * @property {number} width
 * @property {number} height
 * @property {number} x
 * @property {number} y
 *
 * @param {Partial<import('./types').ModalWindowProps>} props
 * @returns {ModalPosition}
 */

var getDefaultPosition = function getDefaultPosition(props) {
  var computed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  /**@type {any} */

  var position = {};

  if (props.style) {
    position = {
      width: props.style.width ? props.style.width : '',
      height: props.style.height ? props.style.height : '',
      x: props.style.left ? props.style.left : 'center',
      y: props.style.top ? props.style.top : 'top'
    };
  }

  if (!position.width || position.width === 'auto') {
    position.width = Math.max(window.innerWidth / 2, 480);
  } else {
    if (typeof position.width === 'string' && position.width.indexOf('%') > -1) {
      var pcWidth = parseFloat(position.width);
      position.width = window.innerWidth * pcWidth / 100;
    }
  } //if (!defaultPos.height) defaultPos.height = window.innerHeight / 2;


  if (!position.x || position.x === 'auto') {
    position.x = (window.innerWidth - position.width) / 2;
    position.x += ELEVATION_OFFSET_PX * (props.elevation - DEFAULT_ELEVATION);
  } else {
    if (position.x === 'center') position.x = (window.innerWidth - position.width) / 2;
  }

  if (!position.y || position.y === 'auto') {
    position.y = ELEVATION_OFFSET_DEFAULT_TOP_PX;
    if (computed.height && typeof computed.height === 'number') position.y = window.innerHeight / 2 - computed.height / 2 - ELEVATION_OFFSET_DEFAULT_TOP_PX;
    position.y += ELEVATION_OFFSET_PX * (props.elevation - DEFAULT_ELEVATION);
  } else {
    if (position.y === 'top') position.y = ELEVATION_OFFSET_DEFAULT_TOP_PX;
  }

  return position;
};

var KEY_MAP = {
  TAB: ['tab', 'shift+tab'],
  FULL_SIZE: 'ctrl+shift+alt+up',
  RESTORE_SIZE: 'ctrl+shift+alt+down',
  MOVE_LEFT: 'ctrl+shift+alt+left',
  MOVE_RIGHT: 'ctrl+shift+alt+right'
};
/**
 * @extends {React.Component<import('./types').ModalWindowProps & import('@material-ui/core').WithStyles<typeof styles>> }
 */

var ModalWindow =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ModalWindow, _React$Component);

  function ModalWindow(props) {
    var _this;

    _classCallCheck(this, ModalWindow);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ModalWindow).call(this, props));

    _this.onRendered = function () {
      _this.updatePosition();
    };

    _this.updatePosition = function () {
      var hasCustomPosition = _this.props.style && _this.props.style.left && _this.props.style.left !== 'auto';
      var nextState = {};

      if (_this.windowRef.current) {
        var nodeSize = _this.windowRef.current.getBoundingClientRect();

        nextState.computed = {
          width: nodeSize.width,
          height: nodeSize.height
        };
      }

      if (!hasCustomPosition) {
        //auto center
        nextState.position = getDefaultPosition(_this.props, nextState.computed);
      }

      _this.setState(nextState);
    };

    _this.onResize = function (e, direction, ref, delta, position) {
      _this.setState(function (prevState) {
        return {
          position: _objectSpread({}, prevState.position, {
            width: ref.offsetWidth,
            height: ref.offsetHeight
          }, position)
        };
      });
    };

    _this.onDragStart = function (e) {
      e.stopPropagation();

      _this.setState({
        isDragging: true
      });
    };

    _this.onDragStop = function (e, d) {
      _this.setState(function (prevState) {
        return {
          position: _objectSpread({}, prevState.position, {
            x: d.x,
            y: d.y
          }),
          isDragging: false
        };
      });
    };

    _this.handleOpen = function () {
      _this.setState({
        opened: true
      });
    };

    _this.handleClose = function () {
      _this.setState({
        opened: false
      });
    };

    _this.onClose = function (e, reason) {
      if (_this.props.onClose) _this.props.onClose(e, reason);
      if (_this.props.children) _this.handleClose();
    };

    _this.onCancel = function (e) {
      _this.onClose(e);

      if (_this.props.footerButtons.cancel && _this.props.footerButtons.cancel.onClick) _this.props.footerButtons.cancel.onClick(e);
    };

    _this.finishSubmit = function (e) {
      if (_this.props.preventWindowClosing) return;
      return _this.onClose(e);
    };

    _this.getSubmitCallback = function () {
      var submitCallback = _this.props.footerButtons && _this.props.footerButtons.submit && _this.props.footerButtons.submit.onClick;
      return submitCallback;
    };

    _this.onSubmit = function (e) {
      var submitCallback = _this.getSubmitCallback();

      var submitReturnValue = null;
      if (submitCallback) submitReturnValue = submitCallback(e);

      if (submitReturnValue && submitReturnValue.then) {
        _this.setState({
          pendingPromise: true
        });

        if (e && e.persist) e.persist();
        return submitReturnValue.then(function () {
          if (!_this.unmounted) {
            _this.setState({
              pendingPromise: false
            });
          }

          return _this.finishSubmit(e);
        }).catch(function () {
          if (!_this.unmounted) {
            _this.setState({
              pendingPromise: false
            });
          }
        });
      } else {
        return _this.finishSubmit(e);
      }
    };

    _this.onLeftAction = function (e) {
      if (_this.props.footerButtons.leftAction && _this.props.footerButtons.leftAction.onClick) _this.props.footerButtons.leftAction.onClick(e);
    };

    _this.renderHeader = function () {
      var header = null;
      if (_this.props.renderHeader) header = _this.props.renderHeader(_this.props.renderArg);else if (_this.props.header) header = _this.props.header;
      if (typeof header === 'string') header = React.createElement(Typography, {
        variant: "h5",
        className: _this.props.classes.windowHeaderText
      }, header);
      return header;
    };

    _this.renderFooter = function () {
      if (_this.props.renderFooter) return _this.props.renderFooter(_this.props.renderArg);
      if (_this.props.footer) return _this.props.footer;

      if (_this.props.footerButtons) {
        var buttons = _this.props.footerButtons;
        var footerContent = null;

        if (buttons.submit || buttons.cancel || buttons.leftAction) {
          footerContent = React.createElement(Grid, {
            container: true,
            direction: "row",
            spacing: 1
          }, buttons.leftAction && React.createElement(Grid, {
            item: true
          }, React.createElement(Button, Object.assign({
            variant: "text",
            color: "primary"
          }, buttons.leftAction, {
            onClick: _this.onLeftAction
          }), buttons.leftAction.children || 'Action')), React.createElement(Grid, {
            item: true,
            xs: true
          }), buttons.cancel && React.createElement(Grid, {
            item: true
          }, React.createElement(Button, Object.assign({
            variant: "outlined",
            color: "default",
            onClick: _this.onCancel
          }, buttons.cancel, {
            disabled: _this.state.pendingPromise
          }), buttons.cancel.children || 'Cancel')), buttons.submit && React.createElement(Grid, {
            item: true
          }, React.createElement(Button, Object.assign({
            variant: "contained",
            color: "primary"
          }, omit(buttons.submit, ['pendingChildren', 'children']), {
            disabled: buttons.submit.disabled !== undefined && buttons.submit.disabled || _this.state.pendingPromise,
            onClick: _this.onSubmit,
            pendingPromise: buttons.submit.pendingChildren
          }), _this.state.pendingPromise ? buttons.submit.pendingChildren || '...' : buttons.submit.children || 'Submit')));
        }

        return footerContent;
      }
    };

    _this.renderContent = function () {
      if (_this.props.renderContent) return _this.props.renderContent(_this.props.renderArg);
      if (_this.props.content) return _this.props.content;
    };

    _this.renderChildren = function () {
      return _this.props.children({
        actions: _this.actions
      });
    };

    _this.state = {
      position: getDefaultPosition(props),
      isDragging: false,
      //present when children prop is used
      opened: null,
      //true when submit callback is a promise and is pending
      pendingPromise: false,
      //true if tab was pressed; used to make close button ignore first tab
      tabKeyPressed: false,
      computed: {
        width: undefined,
        height: undefined
      }
    };
    _this.actions = {
      open: _this.handleOpen,
      close: _this.handleClose
    };
    _this.windowRef = React.createRef();
    _this.keyHandlers = {
      TAB: function TAB(e) {
        if (!_this.state.tabKeyPressed) {
          _this.setState({
            tabKeyPressed: true
          });
        }

        e.stopPropagation();
      },
      FULL_SIZE: function FULL_SIZE() {
        _this.setState({
          position: {
            x: 0,
            y: 0,
            width: window.innerWidth,
            height: window.innerHeight
          }
        });
      },
      RESTORE_SIZE: function RESTORE_SIZE() {
        _this.updatePosition();
      },
      MOVE_LEFT: function MOVE_LEFT() {
        _this.setState({
          position: {
            x: 0,
            y: 0,
            width: window.innerWidth / 2,
            height: window.innerHeight
          }
        });
      },
      MOVE_RIGHT: function MOVE_RIGHT() {
        _this.setState({
          position: {
            x: window.innerWidth / 2,
            y: 0,
            width: window.innerWidth / 2,
            height: window.innerHeight
          }
        });
      }
    };
    return _this;
  }

  _createClass(ModalWindow, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.updatePosition);
      this.updatePosition();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unmounted = true;
      window.removeEventListener('resize', this.updatePosition);
    }
    /**
     * Callback fired once the children has been mounted into the container. It signals that the open={true} prop took effect.
     * This prop will be deprecated and removed in v5, the ref can be used instead.
     */

  }, {
    key: "render",
    value: function render() {
      if (this.props.children && !this.state.opened) return this.renderChildren();
      var _this$props = this.props,
          classes = _this$props.classes,
          elevation = _this$props.elevation,
          hasCloseIcon = _this$props.hasCloseIcon,
          doNotCapitalizeHeader = _this$props.doNotCapitalizeHeader,
          borderLess = _this$props.borderLess,
          error = _this$props.error,
          overlay = _this$props.overlay,
          disableCloseOnEscape = _this$props.disableCloseOnEscape,
          disableRestoreFocus = _this$props.disableRestoreFocus;
      var _this$state = this.state,
          position = _this$state.position,
          isDragging = _this$state.isDragging;
      var hasHeader = this.props.header || this.props.renderHeader;
      var hasFooter = this.props.footer || this.props.renderFooter || this.props.footerButtons;
      var windowContentClass = classes.windowContent;
      var rootStyle = {
        zIndex: elevation + 100
      };
      var browserWindowHeight = window.innerHeight;
      var consumed = (hasFooter ? FOOTER_PX : 0) + (hasHeader ? HEADER_PX : 0);
      var windowContentStyle = {
        maxHeight: browserWindowHeight - (position.y + BOTTOM_SPACE_PX + consumed),
        height: "calc(100% - ".concat(consumed, "px)")
      };
      return React.createElement(React.Fragment, null, this.props.children && this.renderChildren(), React.createElement(Modal, {
        onRendered: this.onRendered,
        "aria-labelledby": "modal window title",
        "aria-describedby": "modal window description",
        open: true,
        onClose: this.onClose,
        hideBackdrop: !overlay,
        disableEscapeKeyDown: disableCloseOnEscape,
        disableRestoreFocus: disableRestoreFocus
      }, React.createElement("div", {
        tabIndex: -1,
        style: {
          outline: 0
        }
      }, React.createElement(Rnd, {
        className: classes.root,
        style: rootStyle,
        size: {
          width: position.width,
          height: position.height
        },
        position: {
          x: position.x,
          y: position.y
        },
        onDragStart: this.onDragStart,
        onDragStop: this.onDragStop,
        onResize: this.onResize,
        dragHandleClassName: classes.paperHeader,
        minHeight: 128,
        minWidth: this.props.style && this.props.style.minWidth ? this.props.style.minWidth : 200,
        maxHeight: browserWindowHeight,
        maxWidth: "100%"
      }, React.createElement(RootRef, {
        rootRef: this.windowRef
      }, React.createElement(Paper, {
        className: classes.paper,
        elevation: isDragging ? 10 : elevation
      }, React.createElement(HotKeys, {
        keyMap: KEY_MAP,
        handlers: this.keyHandlers,
        style: {
          outline: 'none',
          height: '100%'
        }
      }, React.createElement("div", {
        className: classes.paperHeader
      }), React.createElement(Grid, {
        container: true,
        className: hasHeader ? cx(classes.windowHeaderUnderline, classes.windowHeader) : classes.windowHeader,
        style: {
          borderWidth: borderLess ? 0 : ''
        }
      }, hasHeader && React.createElement(Grid, {
        item: true,
        style: {
          textTransform: doNotCapitalizeHeader ? undefined : 'capitalize'
        }
      }, this.renderHeader()), hasCloseIcon && React.createElement(Icon, {
        type: "close",
        color: "inherit",
        onClick: this.onClose,
        disabled: this.state.pendingPromise,
        buttonProps: {
          tabIndex: this.state.tabKeyPressed ? 0 : -1,
          className: classes.closeButton
        },
        className: classes.closeButtonIcon
      })), error && React.createElement(FormError, {
        sticky: true
      }, error), React.createElement("div", {
        className: windowContentClass + ' ModalWindowContent',
        style: windowContentStyle,
        tabIndex: -1
      }, this.renderContent()), hasFooter && React.createElement(Grid, {
        container: true,
        alignItems: "center",
        className: classes.windowFooter,
        style: {
          borderWidth: borderLess ? 0 : ''
        }
      }, React.createElement(Grid, {
        item: true,
        xs: true
      }, this.renderFooter())))))))));
    }
  }]);

  return ModalWindow;
}(React.Component);

var styles = function styles(theme) {
  return createStyles({
    root: {
      display: 'block',
      //@ts-ignore
      position: 'fixed !important',
      width: '100%',
      zIndex: 20,
      outline: 'none'
    },
    paperHeader: {
      cursor: 'move',
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 0,
      top: 0
    },
    paper: theme.mixins.gutters({
      position: 'relative',
      height: '100%',
      paddingLeft: '0 !important',
      paddingRight: '0 !important',
      backgroundColor: '#FFF',
      color: theme.palette.getContrastText('#FFF')
    }),
    windowHeader: {
      padding: theme.spacing(2)
    },
    windowHeaderText: {
      display: '-webkit-box',
      '-webkit-line-clamp': 3,
      '-webkit-box-orient': 'vertical',
      overflow: 'hidden'
    },
    windowHeaderUnderline: {
      borderBottom: "1px solid ".concat(theme.common.divider.color)
    },
    windowFooter: {
      minHeight: theme.spacing(8),
      borderTop: "1px solid ".concat(theme.common.divider.color),
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      bottom: 0,
      backgroundColor: theme.palette.background.paper
    },
    windowContent: {
      position: 'relative',
      height: '100%',
      maxHeight: '100%',
      overflowY: 'auto',
      outline: 'none'
    },
    closeButton: {
      position: 'absolute',
      right: 0,
      top: 0,
      zIndex: 1,
      opacity: 0.5,
      '&:hover, &:focus': {
        opacity: 0.7
      }
    },
    closeButtonIcon: {
      fontSize: '1rem'
    }
  });
};

ModalWindow.defaultProps = {
  elevation: DEFAULT_ELEVATION,
  hasCloseIcon: true,
  doNotCapitalizeHeader: false,
  overlay: true,
  preventWindowClosing: false,
  disableCloseOnEscape: false,
  disableRestoreFocus: false,
  borderLess: false,
  error: null
};
export default withStyles(styles, {
  name: 'ECModalWindow'
})(ModalWindow);